<ng-template #printContainer></ng-template>
<div *ngIf="!currentComponentInstance"
     class="w-full h-full flex justify-center items-center">
  Nothing to print...
</div>
